import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ObjectIdModule} from '../../modules/models'
import {RoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function deleteRoomService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<RoomModel>>(`${BASEURL}/room/deleteRoom`, {
    data: dto,
  })
}
